import BookingCard, { getBookingTypeText } from './BookingCard';

export { getBookingTypeText };

export default BookingCard;
